import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useOrderSuccessViewed = () => {
  usePageViewedEvent({ event: EVENTS.ORDER_SUCCESS_VIEWED });
};
